import { render, staticRenderFns } from "./PhysiciansPie.vue?vue&type=template&id=727cc096&"
import script from "./PhysiciansPie.vue?vue&type=script&lang=js&"
export * from "./PhysiciansPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports